<!-- Evaluation.vue -->
<template>
	<div class="ui-evaluation">
		<div class="ui-evaluation-header">
			<div class="flex-header">
				<div
					v-for="(item, index) in staticData"
					v-bind:key="item.id"
					v-bind:class="{ active: currentTag == item.value }"
					v-on:click="changeTab(item.value, item.grade)"
				>
					{{ item.name }}
				</div>
			</div>
		</div>
		<div
			class="ui-evaluation-body"
			v-infinite-scroll="loadMore"
			infinite-scroll-disabled="loading"
			infinite-scroll-distance="10"
		>
			<div
				class="list"
				v-for="(item, index) in reviewList"
				v-if="reviewList.length > 0"
			>
				<div>
					<span>
						{{ item.geval_isanonymous?'匿名':item.geval_frommembername }}
						<span
							v-bind:class="{
								'good-review': item.geval_scores > 3,
								'medium-review': item.geval_scores > 1,
								'bad-review': item.geval_scores == 1
							}"
							>{{ getGrade(item.geval_scores) }}</span
						>
					</span>
					<span>{{ getTime(item.geval_addtime) }}</span>
				</div>
				<p v-if="item.geval_content">{{ item.geval_content }}</p>
				<p v-if="!item.geval_content">无评价信息</p>
        <div class="evaluate_pic_box">
          <div class="video_bg" v-if="item.evaluate_video">
            <p :class="gernerateClass(item.geval_id)" style="display: none">
              <video data-width="720" data-height="1280" width="100%" height="auto" autoplay :src="item.evaluate_video" webkit-playsinline="true" playsinline="" preload="true" muted="muted" controls="controls" style="width: 92.25%;"><source :src="item.evaluate_video" type="video/mp4">暂时不支持播放该视频</video>
            </p>
            <video data-width="720" data-height="1280" width="100%" height="auto" :src="item.evaluate_video"  muted="muted"><source :src="item.evaluate_video" type="video/mp4">暂时不支持播放该视频</video>
            <div class="button" @click='videoShow(item.geval_id)'></div>
          </div>
          <vue-preview :slides="slide[item.geval_id]" class="preview" :class="item.evaluate_video?'has_video':''"></vue-preview>
        </div>
        <p class="explain" v-if="item.geval_explain">掌柜回复：{{ item.geval_explain }}</p>
			</div>

			<div class="list-empty" v-if="reviewList.length <= 0">
				<p>本商品暂无评价</p>
			</div>

      <!--视频预览-->
      <div id="part_video" class="video_fixed" v-if="video_play">
        <div id="partVideoMain" class="video_fixed_main" data-type="comment" v-html="video_url"></div>
        <div class="video_fixed_close" @click='videoClose()'>退出播放</div>
      </div>

		</div>

	</div>

</template>

<script>
import { evaluation } from '../static'
import { getReviewList } from '../../../../api/homegoodsdetail'
import $ from 'jquery'
import {saveOrderEvaluate} from "@/api/memberOrder";
import {Toast} from "mint-ui";
import {mapMutations} from "vuex";
export default {
  data () {
    return {
      staticData: evaluation,
      id: this.$store.state.goodsdetail.currentProductId
        ? this.$store.state.goodsdetail.currentProductId
        : '',
      currentTag: 'total',
      grade: 0,
      subTotal: {},
      reviewList: [],
      evaluatePic: [],
      page: 0,
      loading: false,
      total: 1,
      video_play: false,
      video_url: '',
      slide: [],
    }
  },
  created () {
  },
  methods: {
    loadMore () {
      this.loading = true
      this.page = ++this.page
      if (this.page <= this.total) {
        this.loading = false
        this.getReviewList(true)
      }
    },
    getReviewList (ispush) {
      getReviewList(this.id, this.grade, this.page).then(res => {
        if (res) {
          if (ispush) {
            this.reviewList = this.reviewList.concat(res.result.goods_eval_list)

            for (var i in this.reviewList) {
              let evaluate_pic_arr = this.reviewList[i].evaluate_pic_arr
              let evaluate_pic_attr_arr = this.reviewList[i].evaluate_pic_attr_arr
              let geval_id = this.reviewList[i].geval_id

              let img2 = []
              let temp = {
                src: '',
                msrc: '',
                alt: '',
                title: '',
                w: 100,
                h: 100
              }

              for (let i2 in evaluate_pic_arr) {

                let w = 400
                let h = 400

                if(evaluate_pic_attr_arr){
                  w = evaluate_pic_attr_arr[i2]['w']
                  h = evaluate_pic_attr_arr[i2]['h']
                }

                temp = {
                  src: evaluate_pic_arr[i2],
                  msrc: evaluate_pic_arr[i2],
                  alt: '',
                  title: '',
                  w: w,
                  h: h
                }

                img2.push(temp)

              }

              this.slide[geval_id] = img2

            }

          } else {

            this.reviewList = res.result.goods_eval_list

          }
          if (res.hasmore) {
            this.loading = false
          } else {
            this.loading = true
          }
          this.total = res.page_total
        }
      })
    },
    changeTab (value, grade) {
      this.currentTag = value
      this.grade = grade
      this.getReviewList(false)
    },
    getGrade (grade) {
      if (grade == 1) {
        return '差评'
      } else if (grade > 3) {
        return '好评'
      } else {
        return '中评'
      }
    },
    getTime (timestamps) {
      let date = new Date(timestamps * 1000)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      return year + '-' + month + '-' + day
    },
    videoShow (index) {
      let video_html = $('.video_'+index).html()
      this.video_play = true
      this.video_url = video_html
    },
    videoClose () {
      this.video_play = false
      this.video_url = ''
    },
    gernerateClass(index) {
      return 'video_' + index
    }

  }
}
</script>
<style lang="scss" scoped>
.ui-evaluation {
	.ui-evaluation-header {
		background: #ffffff;
		.flex-header {
			width: auto;
			display: flex;
			display: -webkit-flex;
			display: -moz-flex;
			flex-basis: 100%;
			justify-content: space-around;
			align-content: center;
			align-items: center;
			height:2.2rem;
			div {
				color: #5c5958;
				font-size:0.7rem;
				height:1.2rem;
				border: 0.5px solid #333;
				padding: 0 0.45rem;
				line-height: 1.2rem;
				text-align: center;
				border-radius: 0.2rem;
				&.active {
					color: #ffffff;
					background: $primaryColor;
					border: 0.5px solid transparent;
				}
			}
		}
	}
	.ui-evaluation-body {
		padding: 0 0.75rem;
		background: rgba(255, 255, 255, 1);
    .list {
      padding: 0.75rem 0;
      border-bottom: 0.5px solid rgba(232, 234, 237, 1);
      color: #333;
      font-size:0.7rem;
    }
    .list>div{
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      align-content: center;
      align-items: center;
    }
    .list>div span{
      &:first-child {
        display: flex;
        justify-content: space-around;
        align-content: center;
        align-items: center;
        span {
          margin-left:0.75rem;
          color: #ffffff;
          font-size:0.6rem;
        }
      }
      &:last-child {
        color: #999999;
        font-size:0.6rem;
      }
      &.good-review {
        background: #fc2e39;
        width:1.8rem;
        height:0.8rem;
        text-align: center;
        background-size: cover;
        line-height:0.8rem;
        border-radius:0.4rem;
      }
      &.medium-review {
        background: #e93b3d;
        width:1.8rem;
        height:0.8rem;
        text-align: center;
        background-size: cover;
        line-height:0.8rem;
        border-radius:0.4rem;
      }
      &.bad-review {
        background: #c3c3c3;
        width:1.8rem;
        height:0.8rem;
        text-align: center;
        background-size: cover;
        line-height:0.8rem;
        border-radius:0.4rem;
      }
    }
    .list p{
      padding: 0;
      margin: 0;
      flex-basis: 100%;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      padding-top:0.75rem;
    }

    /*.evaluate_pic{
      padding-top:0.75rem;
      -webkit-overflow-scrolling: touch;
      overflow: hidden;
      overflow-x: auto;
      white-space: nowrap;
    }
    .evaluate_pic .img{
      background-color: #f3f3f3;
      border-radius: 6px;
      display: inline-block;
      height: 80px;
      margin-right: 6px;
      overflow: hidden;
      text-align: center;
      vertical-align: middle;
      width: 80px;
    }
    .evaluate_pic .img img{
      width: 80px;
      height: 80px;
    }
    .evaluate_pic .video{
      background-color: #f3f3f3;
      border-radius: 6px;
      display: inline-block;
      height: 80px;
      margin-right: 6px;
      overflow: hidden;
      text-align: center;
      vertical-align: middle;
      width: 80px;
      position: relative;
    }
    .evaluate_pic .video .button{
      background: rgba(0,0,0,.5);
      border-radius: 50%;
      height: 40px;
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%,-50%);
      width: 40px;
    }
    .evaluate_pic .video .button:before {
      border-bottom: 9px solid transparent;
      border-left: 15px solid #fff;
      border-top: 9px solid transparent;
      content: "";
      display: block;
      left: 14px;
      position: absolute;
      top: 10px;
    }*/
    .explain{color:orange}

		.list-empty {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			text-align: center;
			img {
				width:2.75rem;
			}
			p {
				color: #7c7f88;
				font-size:0.7rem;
				padding: 0;
				margin: 0;
				font-weight: normal;
			}
		}
	}
}
.video_fixed {
  background-color: #000;
  bottom: 0;
  left: 0;
  margin: 0 auto;
  position: fixed;
  right: 0;
  text-align: center;
  top: 0;
  z-index: 302
}
.video_fixed video {
  background: #000;
  height: 100%;
  width: 100%
}
.video_fixed_main {
  font-family: none;
  font-size: 0;
  max-width: none;
  overflow: hidden;
  white-space: nowrap;
  margin-top: 0;
  max-height: none;
}
.video_fixed_close {
  background: hsla(0, 0%, 100%, .8);
  border-radius: 15px;
  box-shadow: 0 2.5px 5px 0 rgba(0, 0, 0, .05);
  color: #333;
  display: inline-block;
  font-size: 12px;
  letter-spacing: 0;
  margin-top: 15px;
  padding: 2px 15px;
  text-align: center;
  position: absolute;
  z-index: 2;
  top: 10px;
  left: 50%;
  margin-left: -39px;
}

.preview-picture {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 10;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #000;
  .picture-header {
    height: 2.2rem;
    color: #000;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    width: 100%;
    top: 0;
    span {
      font-size: 0.7rem;
      font-weight: normal;
      &:first-child {
        cursor: pointer;
        position: absolute;
        left: 0.75rem;

        background-size: 1.2rem;
        display: inline-block;
        height: 2.2rem;
        line-height: 2.2rem;
      }
    }
  }
  .picture-body {
    position: absolute;
    top: 2.2rem;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
  }
}

.evaluate_pic_box{
  position: relative;
  margin-top:0.75rem;
}
.evaluate_pic_box .video_bg{
  width: 80px;
  height: 80px;
  background: #ccc;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 6px;
  overflow: hidden;
}
.evaluate_pic_box .video_bg .button{
  background: rgba(0,0,0,.5);
  border-radius: 50%;
  height: 40px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%,-50%);
  width: 40px;
}
.evaluate_pic_box .video_bg .button:before {
  border-bottom: 9px solid transparent;
  border-left: 15px solid #fff;
  border-top: 9px solid transparent;
  content: "";
  display: block;
  left: 14px;
  position: absolute;
  top: 10px;
}

</style>